<template>
  <div>
    <CCard>
      <CCardHeader>
        <strong> アカウント情報 </strong>
        <CRow style="float: right">
          <CButton color="info" @click="showModal" class="mr-1"> 編集 </CButton>
        </CRow>
      </CCardHeader>
      <CAlert v-if="alertMsg" :color="alertClr" fade>
        {{ alertMsg }}
      </CAlert>
      <!-- タブレット、PC等ミディアム、ラージデバイス用 -->
      <CCardBody class="pcBody">
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay">社員番号</CCardHeader>
            <CCardBody>{{ items.user_id }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay"
              >メールアドレス</CCardHeader
            >
            <CCardBody>{{ items.email }}</CCardBody>
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay">国籍</CCardHeader>
            <CCardBody>{{ items.nationality }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay">氏名</CCardHeader>
            <CCardBody>{{ items.lastname }} {{ items.firstname }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay">フリガナ</CCardHeader>
            <CCardBody
              >{{ items.lastname_kana }} {{ items.firstname_kana }}</CCardBody
            >
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay">性別</CCardHeader>
            <CCardBody>{{ this.gender_mame }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay">生年月日</CCardHeader>
            <CCardBody>{{ items.birthday }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay">最寄り駅</CCardHeader>
            <CCardBody>{{ items.nearest_station }}</CCardBody>
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay"
              >入社前業界経験年数</CCardHeader
            >
            <CCardBody>{{ items.years_experience }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay">最終学歴</CCardHeader>
            <CCardBody>{{ this.latest_academic_mame }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay"
              >最終学歴_卒業年度</CCardHeader
            >
            <CCardBody>{{ items.graduate_year }}</CCardBody>
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay">入社年月日</CCardHeader>
            <CCardBody>{{ items.joining_date }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay"
              >所属組織略称</CCardHeader
            >
            <CCardBody> {{ this.abbreviation }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay">所属組織名</CCardHeader>
            <CCardBody> {{ this.organization_name }}</CCardBody>
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay">役職名</CCardHeader>
            <CCardBody> {{ this.position_name }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0">
            <CCardHeader class="labelsFont bgColorGlay">契約形態</CCardHeader>
            <CCardBody>{{ this.working_status_mame }}</CCardBody>
          </CCol>
          <CCol class="px-0">
            <CCardHeader class="labelsFont bgColorGlay">就業状態</CCardHeader>
            <CCardBody>{{ this.employment_status_mame }}</CCardBody>
          </CCol>
          <CCol class="pl-0">
            <CCardHeader class="labelsFont bgColorGlay"
              >閲覧権限種別</CCardHeader
            >
            <CCardBody> {{ this.authority_name }}</CCardBody>
          </CCol>
        </CRow>
      </CCardBody>

      <!-- スマホ等スモールデバイス用 -->
      <CCardBody class="spBody">
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">社員番号</CCardHeader>
            <CCardBody>{{ items.user_id }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay"
              >メールアドレス</CCardHeader
            >
            <CCardBody>{{ items.email }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">国籍</CCardHeader>
            <CCardBody>{{ items.nationality }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">氏名</CCardHeader>
            <CCardBody>{{ items.lastname }} {{ items.firstname }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">フリガナ</CCardHeader>
            <CCardBody
              >{{ items.lastname_kana }} {{ items.firstname_kana }}</CCardBody
            >
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">性別</CCardHeader>
            <CCardBody>{{ this.gender_mame }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">生年月日</CCardHeader>
            <CCardBody>{{ items.birthday }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">最寄り駅</CCardHeader>
            <CCardBody>{{ items.nearest_station }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay"
              >入社前業界経験年数</CCardHeader
            >
            <CCardBody>{{ items.years_experience }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">最終学歴</CCardHeader>
            <CCardBody>{{ this.latest_academic_mame }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay"
              >最終学歴_卒業年度</CCardHeader
            >
            <CCardBody>{{ items.graduate_year }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">入社年月日</CCardHeader>
            <CCardBody>{{ items.joining_date }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay"
              >所属組織略称</CCardHeader
            >
            <CCardBody> {{ this.abbreviation }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">所属組織名</CCardHeader>
            <CCardBody> {{ this.organization_name }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">役職名</CCardHeader>
            <CCardBody> {{ this.position_name }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">契約形態</CCardHeader>
            <CCardBody>{{ this.working_status_mame }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay">就業状態</CCardHeader>
            <CCardBody>{{ this.employment_status_mame }}</CCardBody>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCardHeader class="labelsFont bgColorGlay"
              >閲覧権限種別</CCardHeader
            >
            <CCardBody> {{ this.authority_name }}</CCardBody>
          </CCol>
        </CRow>
      </CCardBody>
      <AccountEditModal
        :visible="editModalVisible"
        :data="inputItems"
        @close="closeEditModal($event)"
      />
    </CCard>
  </div>
</template>

<script>
import contracts from "../../../definition/working-status.json";
import educations from "../../../definition/latest-academic.json";
import employments from "../../../definition/employment-status.json";
import genders from "../../../definition/gender.json";
import AccountEditModal from "./AccountEditModal.vue";

export default {
  name: "Account",
  data() {
    return {
      items: {},
      gender_mame: "",
      organization_name: "",
      working_status_mame: "",
      employment_status_mame: "",
      latest_academic_mame: "",
      abbreviation: "",
      organization_name: "",
      position_name: "",
      authority_name: "",
      editModalVisible: false,
      inputItems: {},
      alertMsg: "",
      alertClr: "",
    };
  },
  components: {
    AccountEditModal,
  },
  async created() {
    //ログインID取得
    const user_id = this.$store.state.loginUser.user_id;
    await this.getProfileData(user_id);
  },
  methods: {
    async fetchData(id) {
      await this.$axios
        .get("/api/v1/users/" + id)
        .then((res) => {
          this.items = res.data.users;
        })
        .catch((e) => {
          this.errorMsg = "Error! Could not reach the API. " + e;
          console.log(this.errorMsg);
        });
    },
    setAlert(altObj) {
      if (altObj) {
        this.alertClr = altObj.alertClr;
        this.alertMsg = altObj.alertMsg;
        // 画面上部までスクロールする
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
    showModal() {
      this.editModalVisible = true;
      //更新モーダルに値を渡す
      this.inputItems = this.items;
      // メッセージを非表示
      this.alertMsg = "";
    },
    closeEditModal(result) {
      this.editModalVisible = false;
      // 表示アラート設定
      this.setAlert(result);
      // データ更新
      //ログインID取得
      const user_id = this.$store.state.loginUser.user_id;
      this.getProfileData(user_id);
    },
    async getProfileData(user_id) {
      //データ取得
      await this.fetchData(user_id);
      this.abbreviation = this.items.m_organization.abbreviation;
      this.organization_name = this.items.m_organization.organization_name;
      this.position_name = this.items.m_position.position_name;
      this.authority_name = this.items.m_authority.authority_name;
      //性別名称取得
      genders.find((gender) => {
        if (this.items.gender_id == gender.value) {
          this.gender_mame = gender.label;
        }
      });
      //最終学歴名称取得
      educations.find((education) => {
        if (this.items.latest_academic_id == education.value) {
          this.latest_academic_mame = education.label;
        }
      });
      //契約状態取得
      contracts.find((contract) => {
        if (this.items.working_status == contract.value) {
          this.working_status_mame = contract.label;
        }
      });
      //就業状態取得
      employments.find((employment) => {
        if (this.items.employment_status == employment.value) {
          this.employment_status_mame = employment.label;
        }
      });
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .pcBody {
    display: block !important;
  }
  .spBody {
    display: none !important;
  }
  .labelsFont {
    font-weight: bold;
  }
  .bgColorGlay {
    background-color: whitesmoke;
  }
}
</style>
<style scoped>
/* スマホ等スモールデバイス用CSS */
@media screen and (max-width: 767px) {
  .pcBody {
    display: none !important;
  }
  .spBody {
    display: block !important;
  }
  .labelsFont {
    font-weight: bold;
  }
  .bgColorGlay {
    background-color: whitesmoke;
  }
}
</style>